"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _FormatSize = _interopRequireDefault(require("@material-ui/icons/FormatSize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var field = {
  operators: [{
    value: '=',
    label: '='
  }, {
    value: '>',
    label: '>'
  }, {
    value: '<',
    label: '<'
  }, {
    value: '!=',
    label: '!='
  }, {
    value: '<=',
    label: '<='
  }, {
    value: '>=',
    label: '>='
  }, {
    value: 'like',
    label: 'like'
  }, {
    value: '!like',
    label: '!like'
  }],
  defaultOperator: 'like',
  filter: function filter(rawValue, q) {
    if (rawValue === void 0) {
      rawValue = '';
    }

    var operator = q.operator,
        qv = q.value,
        _q$isCaseSensitive = q.isCaseSensitive,
        isCaseSensitive = _q$isCaseSensitive === void 0 ? false : _q$isCaseSensitive;

    if (qv !== '') {
      var queryValue = qv;
      var value = rawValue;

      if (isCaseSensitive) {
        queryValue = qv != null ? qv.toUpperCase() : qv;
        value = value != null ? value.toUpperCase() : qv;
      }

      switch (operator) {
        case '=':
          return value === queryValue;

        case '>':
          return value.localeCompare(queryValue) > 0;

        case '<':
          return value.localeCompare(queryValue) < 0;

        case '!=':
          return value !== queryValue;

        case '<=':
          return value.localeCompare(queryValue) <= 0;

        case '>=':
          return value.localeCompare(queryValue) >= 0;

        case 'like':
          return value.indexOf(queryValue) !== -1;

        case '!like':
          return value.indexOf(queryValue) === -1;

        default:
          return false;
      }
    } else {
      return true;
    }
  },
  sort: function sort(orientation, a, b) {
    var result = a < b ? -1 : a > b ? 1 : 0;
    return result * orientation;
  },
  render: function render(_ref, _onChange) {
    var _ref$value = _ref.value,
        value = _ref$value === void 0 ? '' : _ref$value,
        _ref$isCaseSensitive = _ref.isCaseSensitive,
        isCaseSensitive = _ref$isCaseSensitive === void 0 ? false : _ref$isCaseSensitive;
    return /*#__PURE__*/_react.default.createElement(_TextField.default, {
      variant: "outlined",
      style: {
        padding: 1
      },
      type: "text",
      value: value,
      fullWidth: true,
      onChange: function onChange(e) {
        return _onChange({
          value: e.target.value
        });
      },
      InputProps: {
        endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
          position: "end"
        }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
          color: isCaseSensitive ? 'secondary' : 'primary',
          onClick: function onClick() {
            return _onChange({
              isCaseSensitive: !isCaseSensitive
            });
          }
        }, /*#__PURE__*/_react.default.createElement(_FormatSize.default, null)))
      }
    });
  }
};
var _default = field;
exports.default = _default;
module.exports = exports.default;